import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { getActiveCode } from "../helper/currencyState";

let __aedNoteSeq = 0;

const AedChargeNote = ({ amount, currencyCode, align = "end", className = "" }) => {
  const idRef = React.useRef(null);
  if (idRef.current === null) {
    idRef.current = "aed-charge-note-" + ++__aedNoteSeq;
  }

  const code = currencyCode !== undefined ? currencyCode : getActiveCode();
  if (!code || String(code).toUpperCase() === "AED") return null;

  const value = Number(amount || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const message =
    "All transactions will be processed in AED. Displayed amounts in other currencies are for reference only.";

  return (
    <div
      className={
        "hw-aedChargeNote d-flex align-items-center " +
        (align === "end" ? "justify-end " : "") +
        "w-100 " +
        className
      }
      style={{ gap: "5px", marginTop: "2px" }}
    >
      <span style={{ fontSize: "12px", fontWeight: 500, color: "#555555" }}>
        You&apos;ll pay AED {value}
      </span>
      <span
        data-tooltip-id={idRef.current}
        data-tooltip-content={message}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#8a8a8a",
          cursor: "pointer",
          flexShrink: 0,
        }}
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
          <path d="M12 11v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <circle cx="12" cy="7.6" r="1.2" fill="currentColor" />
        </svg>
      </span>
      <ReactTooltip
        id={idRef.current}
        place="top"
        variant="light"
        style={{
          maxWidth: "240px",
          textAlign: "left",
          borderRadius: "6px",
          fontSize: "11px",
          lineHeight: "1.45",
          zIndex: 9999,
        }}
      />
    </div>
  );
};

export default AedChargeNote;
